<div 
  [class]="size === 'default' ? 'card-default' : 'card-small'"
  (click)="onCardClick()"
  class="bg-white border-0 rounded-[30px] shadow-tertiary cursor-pointer transition-all hover:shadow-tertiary-xl">
  
  @if (size === 'default') {
    <!-- Default size card: 280x305 -->
    <div class="card-default-content">
      <div class="icon-container">
        <img [src]="img" [alt]="title" class="icon-image">
      </div>
      
      <h3 class="card-title">{{ title | translate }}</h3>
      
      @if (description) {
        <p class="card-description">{{ description | translate }}</p>
      }
      
      <div class="arrow-container">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  } @else {
    <!-- Small size card: 140x160 -->
    <div class="card-small-content">
      <div class="icon-container-small">
        <img [src]="img" [alt]="title" class="icon-image-small">
      </div>
      
      <h3 class="card-title-small">{{ title | translate }}</h3>
    </div>
  }
</div>
